// Platform ports (CLAUDE.md §1.1). Web adapters: fetch transport, IndexedDB store, navigator/probe
// connectivity, Date clock, crypto UUIDv7. Future native clients implement the same contracts.
import type { Operation, OperationResult, PullPage } from '@/sync/ops';

export interface Clock { now(): number }
export interface IdGenerator { next(): string }

export type TransportErrorKind = 'network' | 'auth' | 'forbidden' | 'conflict' | 'rejected' | 'server' | 'cursor_expired';
export class TransportError extends Error {
  constructor(public readonly kind: TransportErrorKind, message: string, public readonly status = 0, public readonly code = '') { super(message); }
}

/** JSON API transport; implementations must never retry silently — the sync engine owns retries. */
export interface SyncTransport {
  push(workspaceId: string, deviceId: string, ops: Operation[]): Promise<OperationResult[]>;
  pull(workspaceId: string, cursor: string | null, limit: number, projectId?: string): Promise<PullPage>;
}

/** Real reachability, not navigator.onLine alone. */
export interface Connectivity {
  probe(): Promise<boolean>;
  onChange(cb: (online: boolean) => void): () => void;
}

export const systemClock: Clock = { now: () => Date.now() };
